import { CheckPayeeMatchStatus, FormFieldConfig } from '@finxone-platform/shared/sys-config-types';
import { Store } from '@ngxs/store';
import {
  accountNotSupported,
  accountNumberIncorrect,
  accountSwitched,
  invalidSecondaryIdentifier,
  noMatch,
  optedOut,
  sortCodeNotSupported,
} from '@finxone-platform/shared/default-templates';
import { SetCopResponseStateReason } from '@app/finxone-web-frontend/app/lib/actions/cop-response.action';

/**
 * Sets a validation property for a given field name in inputFieldConfigs.
 * If the field already has a validation object, it merges the new validation property.
 */
export function setFieldValidation(
  fieldName: string,
  inputFieldConfigs: FormFieldConfig[],
  validationKey: string,
  validationValue: any,
): void {
  const fieldIndex = inputFieldConfigs.findIndex((f) => f.name === fieldName);
  if (fieldIndex !== -1) {
    inputFieldConfigs[fieldIndex] = {
      ...inputFieldConfigs[fieldIndex],
      validation: {
        ...(inputFieldConfigs[fieldIndex].validation ?? {}),
        [validationKey]: validationValue,
      },
    };
  }
}

export function setNoMatchReasonFromResponse(response: string, store: Store) {
  let noMatchReason: string;
  switch (response) {
    case CheckPayeeMatchStatus.ACCOUNT_SWITCHED:
      noMatchReason = accountSwitched;
      break;
    case CheckPayeeMatchStatus.ACCOUNT_NOT_SUPPORTED:
      noMatchReason = accountNotSupported;
      break;
    case CheckPayeeMatchStatus.OPTED_OUT:
      noMatchReason = optedOut;
      break;
    case CheckPayeeMatchStatus.INVALID_SECONDARY_IDENTIFIER:
      noMatchReason = invalidSecondaryIdentifier;
      break;
    case CheckPayeeMatchStatus.SORT_CODE_NOT_SUPPORTED:
      noMatchReason = sortCodeNotSupported;
      break;
    case CheckPayeeMatchStatus.ACCOUNT_NUMBER_INCORRECT:
      noMatchReason = accountNumberIncorrect;
      break;
    default:
      noMatchReason = noMatch;
      break;
  }
  store.dispatch(new SetCopResponseStateReason(noMatchReason));
}

export function formatSortCode(sortCodeValue = ''): string {
  const cleaned = sortCodeValue.replaceAll('-', '');
  if (/^\d{6}$/.test(cleaned)) {
    return `${cleaned.slice(0, 2)}-${cleaned.slice(2, 4)}-${cleaned.slice(4, 6)}`;
  }
  return sortCodeValue;
}
